/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Container, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";
import Constants from "../../utilities/Constants";
import Strings from "../../utilities/StringSelector";
import Utils from "../../utilities/Utils";

const UtilsInstance = new Utils();

export class TsExpertConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,

      isAttenuatedSignalProblemChecked: false,
      isDeviationJitterProblemChecked: false,
      isNoiseProblemChecked: false,
      isRetryProblemChecked: false,
      isFaultProblemChecked: false,
      isInvertedPolarityChecked: true,
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig/" + this.props.channel, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isAttenuatedSignalProblemChecked: data.isAttenuatedSignalProblemChecked,
        isDeviationJitterProblemChecked: data.isDeviationJitterProblemChecked,
        isNoiseProblemChecked: data.isNoiseProblemChecked,
        isRetryProblemChecked: data.isRetryProblemChecked,
        isFaultProblemChecked: data.isFaultProblemChecked,
      }));
  }

  // ------ Toggle Checkboxes ---------
  toggleIsAttenuatedSignalProblemChecked = () => {
    this.setState({ isAttenuatedSignalProblemChecked: !this.state.isAttenuatedSignalProblemChecked });
  }

  toggleIsDeviationJitterProblemChecked = () => {
    this.setState({ isDeviationJitterProblemChecked: !this.state.isDeviationJitterProblemChecked });
  }

  toggleIsNoiseProblemChecked = () => {
    this.setState({ isNoiseProblemChecked: !this.state.isNoiseProblemChecked });
  }

  toggleIsRetryProblemChecked = () => {
    this.setState({ isRetryProblemChecked: !this.state.isRetryProblemChecked });
  }

  toggleIsFaultProblemChecked = () => {
    this.setState({ isFaultProblemChecked: !this.state.isFaultProblemChecked });
  }

  toggleIsInvertedPolarityChecked = () => {
    alert(Strings.TS_EXPERT_INVERTED_POLARITY_DISABLE_NOT_ALLOWED);
  }

  // Save the TS Expert Configuration
  saveTsExpertConfiguration = () => {
    this.showSendingConfigDimmer();

    let data = {
      isAttenuatedSignalProblemChecked: this.state.isAttenuatedSignalProblemChecked,
      isDeviationJitterProblemChecked: this.state.isDeviationJitterProblemChecked,
      isNoiseProblemChecked: this.state.isNoiseProblemChecked,
      isRetryProblemChecked: this.state.isRetryProblemChecked,
      isFaultProblemChecked: this.state.isFaultProblemChecked,
    };

    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig_POST/" + this.props.channel, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.ERROR_REASON + error);
      })
      .finally(this.hideSendingConfigDimmer);
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });

  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Container>

        <Segment>
          <Header as='h2' textAlign="center" color="teal">
            {Strings.TS_EXPERT_CONFIGURATION}
          </Header>
          <Divider clearing />

          <Segment id="problems-list" style={listSegmentStyle} basic>

            <List divided verticalAlign='middle'>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.ASI_ATTENUATED_SIGNAL_LIST_HEADER}</List.Header>
                      {Strings.ASI_ATTENUATED_SIGNAL_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsAttenuatedSignalProblemChecked}
                        checked={this.state.isAttenuatedSignalProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <Grid columns={2}>
                    <Grid.Column width={14}>
                      <List.Header>{Strings.ASI_DEVIATION_LIST_HEADER}</List.Header>
                      {Strings.ASI_DEVIATION_LIST_CONTENT}
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                      <Checkbox
                        toggle
                        onChange={this.toggleIsDeviationJitterProblemChecked}
                        checked={this.state.isDeviationJitterProblemChecked} />
                    </Grid.Column>
                  </Grid>
                </List.Content>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.ASI_NOISE_LIST_HEADER}</List.Header>
                    {Strings.ASI_NOISE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsNoiseProblemChecked}
                      checked={this.state.isNoiseProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.ASI_RETRY_LIST_HEADER}</List.Header>
                    {Strings.ASI_RETRY_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsRetryProblemChecked}
                      checked={this.state.isRetryProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.ASI_FAULT_LIST_HEADER}</List.Header>
                    {Strings.ASI_FAULT_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsFaultProblemChecked}
                      checked={this.state.isFaultProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

              <List.Item>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.ASI_INVERTED_POLARITY_LIST_HEADER}</List.Header>
                    {Strings.ASI_INVERTED_POLARITY_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsInvertedPolarityChecked}
                      checked={this.state.isInvertedPolarityChecked} />
                  </Grid.Column>
                </Grid>
              </List.Item>

            </List>

          </Segment>

          <Button
            fluid
            color="teal"
            content={Strings.SAVE}
            onClick={this.saveTsExpertConfiguration} />

          <Dimmer active={this.state.isSendingConfigDimmerActive} >
            <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
          </Dimmer>

        </Segment>

      </Container>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "310px"
};

export default TsExpertConfig;
